import React, { useEffect } from 'react';
import { Translate, translate, ValidatedForm } from 'react-jhipster';
import { toast } from 'react-toastify';

import { ArrowBack } from '@mui/icons-material';
import { Alert, Box, Button, Grid, TextField, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Login } from 'app/shared/layout/login/Login';
import { Redirect, useHistory } from 'react-router-dom';
import { handlePasswordResetInit, reset } from '../password-reset.reducer';

export const PasswordResetInit = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [email, setEmail] = React.useState('');

  useEffect(
    () => () => {
      dispatch(reset());
    },
    []
  );

  const handleValidSubmit = () => {
    dispatch(handlePasswordResetInit(email));
  };

  const successMessage = useAppSelector(state => state.passwordReset.successMessage);

  useEffect(() => {
    if (successMessage) {
      toast.success(translate(successMessage), { autoClose: 10000 });
    }
  }, [successMessage]);

  return (
    <Login>
      {successMessage && <Redirect to={'/'} />}
      <Typography color="secondary" fontWeight={'700'} component="h1" variant="h5" align="center" sx={{ mb: { xs: 4, md: 6 }, mt: { xs: 6, md: 8 } }}>
        <Translate contentKey="fleetSenseApp.reset.request.title">Reset password</Translate>
      </Typography>
      <Grid container spacing={3} sx={{ minHeight: '380px', position: 'relative' }}>
        <Grid item xs={12} sm={12}>
          <ValidatedForm onSubmit={handleValidSubmit}>
            <Alert color="warning" sx={{ marginBottom: 2 }}>
              <Translate contentKey="fleetSenseApp.reset.request.messages.info">Enter the email address you used to register</Translate>
            </Alert>
            <TextField
              name="email"
              type="email"
              label={translate('global.form.email.label')}
              placeholder={translate('global.form.email.placeholder')}
              variant="outlined"
              required
              autoFocus
              fullWidth
              color="secondary"
              data-cy="emailResetPassword"
              value={email}
              onChange={e => setEmail(e.target.value)}
              inputProps={{
                maxLength: 50,
                style: { color: 'primary' },
              }}
              InputProps={{
                style: { borderRadius: '8px' },
              }}
              sx={{ marginBottom: 5 }}
            />

            <Box
              display={'flex'}
              color={'text.primary'}
              sx={{ justifyContent: 'flex-end', padding: '24px 0px 24px 24px', position: 'absolute', bottom: 0, right: 0 }}
            >
              <Button variant={'text'} color="secondary" onClick={() => history.goBack()} startIcon={<ArrowBack />}>
                <Typography color="text.primary">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </Typography>
              </Button>

              <Button
                variant={'contained'}
                type="submit"
                color="secondary"
                size="large"
                sx={{
                  fontWeight: '800',
                  marginLeft: '16px',
                }}
              >
                <Translate contentKey={'fleetSenseApp.reset.request.form.button'}>Save</Translate>
              </Button>
            </Box>
          </ValidatedForm>
        </Grid>
      </Grid>
    </Login>
  );
};

export default PasswordResetInit;
